import { connect } from 'react-redux';
import Resume from './Resume';
import timeDepositActions from '../../../../store/actions/timeDeposit.action';
import userActions from '../../../../store/actions/user.action';
import accountActions from '../../../../store/actions/account.action';
import challengeActions from '../../../../store/actions/challenge.action';

const mapStateToProps = state => ({
  timeDeposit: state.timeDeposit.timeDeposit,
  email: state.user.email,
  accounts: state.account.list,
  account: state.liquidate.account,
  isLoading: state.account.loading,
  montoLimitDap: state.simulation.montoLimitDap
});

const mapDispatchToProps = dispatch => {
  return {
    getPersonalInfo: () => {
      dispatch(userActions.getPersonalInfo());
    },
    getAccounts: () => {
      dispatch(accountActions.getAccounts('SIGHT'));
    },
    changeAccount: account => {
      dispatch(timeDepositActions.changeAccount(account));
    },
    liquidateTimeDeposit: params => {
      dispatch(timeDepositActions.liquidateTimeDeposit(params));
    },
    changeEmail: email => {
      dispatch(userActions.changeEmail(email));
    },
    getChallenge: id => {
      dispatch(challengeActions.getChallenges(id));
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Resume);
